import { BiError } from 'react-icons/bi';
import { buttonVariants, Text, VStack } from 'ui_2';
import { Route as index_route } from '@src/routes/index';
import { Link } from '@tanstack/react-router';
import { useEffect } from 'react';

const formatErrorMessage = (err: unknown): string => {
  if (typeof err === 'string') {
    return err;
  }

  const errorObj = err as Error;
  const hasName = errorObj.name && errorObj.name.trim() !== '';

  return hasName ? `${errorObj.name}: ${errorObj.message}` : errorObj.message;
};

export const ErrorMessage = ({
  error,
  fullPageHeight = true,
}: {
  error: unknown;
  fullPageHeight?: boolean;
}) => {
  useEffect(() => {
    console.error('Error in ErrorMessage', error);
  }, [error]);

  const errorMessage = formatErrorMessage(error);

  return (
    <VStack
      className={`flex ${
        fullPageHeight ? 'min-h-[100dvh]' : 'h-full'
      } items-center justify-center bg-gray-50`}
    >
      <VStack className='max-w-[80%] items-center gap-2 rounded-[10px] p-4 text-center'>
        <BiError className='text-red-600' size={32} />
        <VStack>
          <Text color='red'>There was an error loading the page</Text>
          <Text color='red'>{errorMessage}</Text>
        </VStack>
        <Link
          to={index_route.to}
          className={buttonVariants({ variant: 'gray', className: 'w-4/5' })}
          search={{
            tab: 'home',
          }}
        >
          Take me home
        </Link>
      </VStack>
    </VStack>
  );
};
